import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import createMigrate from "redux-persist/es/createMigrate";
import storageSession from "redux-persist/lib/storage/session";
import autoMergeLevel2 from "redux-persist/es/stateReconciler/autoMergeLevel2";

import consentPrivacyReducer, {
  currentVersion as consentPrivacyCurrentVersion,
  migrations as consentPrivacyMigrations,
} from "./consentPrivacyReducer";

import settingsReducer, {
  currentVersion as settingCurrentVersion,
  migrations as settingMigrations,
} from "./settingsReducer";

import fileRequestsPublicReducer, {
  currentVersion as frPublicCurrentVersion,
  migrations as frPublicMigrations,
} from "./fileRequestsPublicReducer";

import uiReducer from "./uiReducer";

const persistedConsentMsgReducer = persistReducer(
  {
    key: "consentPrivacy",
    storage: storage,
    whitelist: ["consentPrivacy"],
    version: consentPrivacyCurrentVersion,
    migrate: createMigrate(consentPrivacyMigrations, {
      debug: !["PRODUCTION"].includes(process.env.REACT_APP_ENV),
    }),
    stateReconciler: autoMergeLevel2,
    debug: !["PRODUCTION"].includes(process.env.REACT_APP_ENV),
  },
  consentPrivacyReducer
);

const persistedSettingsReducer = persistReducer(
  {
    key: "settings",
    storage: storageSession,
    whitelist: ["settings"],
    version: settingCurrentVersion,
    migrate: createMigrate(settingMigrations, {
      debug: !["PRODUCTION"].includes(process.env.REACT_APP_ENV),
    }),
    stateReconciler: autoMergeLevel2,
    debug: !["PRODUCTION"].includes(process.env.REACT_APP_ENV),
  },
  settingsReducer
);

const persistedFileRequestsPublicReducer = persistReducer(
  {
    key: "fileRequestsPublic",
    storage: storageSession,
    whitelist: [
      "profile",
      "senderDraft",
      "currentRequestKey",
      "verifiedEmail",
    ],
    version: frPublicCurrentVersion,
    migrate: createMigrate(frPublicMigrations, {
      debug: !["PRODUCTION"].includes(process.env.REACT_APP_ENV),
    }),
    stateReconciler: autoMergeLevel2,
    debug: !["PRODUCTION"].includes(process.env.REACT_APP_ENV),
  },
  fileRequestsPublicReducer
);

export {
  persistedConsentMsgReducer as consentPrivacyReducer,
  persistedSettingsReducer as settingsReducer,
  persistedFileRequestsPublicReducer as fileRequestsPublicReducer,
  uiReducer,
};
